<script lang="ts">
  import { getContext, setContext, onMount, hasContext } from "svelte";
  import { writable, derived } from "svelte/store";
  import { LOCATION, ROUTER } from "./contexts.js";
  import { globalHistory } from "./history.js";
  import type { StateLocation } from "./route_location.js";
  import { pick, match, stripSlashes, combinePaths } from "./utils.js";
  import { URLComponents, RouterContext, Route, ActiveRoute } from "./utils2.js";

  export let url: string | null = null;

  const routes = writable<Route[]>([]);
  const activeRoute = writable<ActiveRoute | null>(null);
  let hasActiveRoute = false; // Used in SSR to synchronously set that a Route is active.

  let u = url ? new URL(url) : null;
  const location = writable<StateLocation>(
    u ? { pathname: u.pathname, search: u.search, hash: u.hash, state: {} } : globalHistory.location
  );

  function registerRoute(route: Route) {
    // let { path } = route;

    if (typeof window === "undefined") {
      // // In SSR we should set the activeRoute immediately if it is a match.
      // // If there are more Routes being registered after a match is found,
      // // we just skip them.
      // if (hasActiveRoute) {
      //   return;
      // }
      // const matchingRoute = match(route, $location.pathname);
      // if (matchingRoute) {
      //   activeRoute.set(matchingRoute);
      //   hasActiveRoute = true;
      // }
    } else {
      routes.update((rs) => {
        rs.push(route);
        return rs;
      });
    }
  }

  function unregisterRoute(route: Route) {
    routes.update((rs) => {
      const index = rs.indexOf(route);
      rs.splice(index, 1);
      return rs;
    });
  }

  function bestRoute(routes: Route[], url: string): ActiveRoute | null {
    const components = URLComponents(url);
    for (let i = 0; i < routes.length; i++) {
      const path = routes[i].path;
      if (path !== null) {
        const parsed = path.parse(components);
        if (parsed !== null)
          return {
            route: routes[i],
            params: parsed,
          };
      }
    }
    // Check for a fallback route
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].path == null)
        return {
          route: routes[i],
          params: null,
        };
    }
    return null;
  }

  // This reactive statement will be run when the Router is created
  // when there are no Routes and then again the following tick, so it
  // will not find an active Route in SSR and in the browser it will only
  // pick an active Route after all Routes have been registered.
  $: {
    const bestMatch = bestRoute($routes, $location.pathname);
    activeRoute.set(bestMatch);
  }

  // The Router in the tree is responsible for updating
  // the location store and supplying it through context.
  onMount(() => {
    const unlisten = globalHistory.listen((history) => {
      location.set(history.location);
    });

    return unlisten;
  });

  setContext(LOCATION, location);

  setContext(ROUTER, {
    activeRoute,
    registerRoute,
    unregisterRoute,
  });
</script>

<slot />
